import { ListItemText, ListItemIcon, Badge, ListItemButton } from "@mui/material";
import { useStyles } from "./Menu.styles";

type BadgedItemProps = {
	keyName: string;
	title: string;
	badgeCount: number;
	selectedIndex?: string | number;
	onClick: (e: React.MouseEvent, key: string) => void;
	icon: React.ReactNode;
};
export const BadgedItem = (props: BadgedItemProps) => {
	const classes = useStyles(props);
	const {
		keyName,
		badgeCount,
		selectedIndex,
		onClick,
		icon,
		title,
	} = props;
	
	return (
		<ListItemButton
			className={classes.menuIcon}
			key={keyName}
			selected={selectedIndex === keyName}
			onClick={(e) => onClick(e, keyName)}
		>
			<ListItemIcon className={classes.listItemIcon}>
				<Badge overlap="rectangular" className={classes.badge} badgeContent={badgeCount} color="error">
					{icon}
				</Badge>
			</ListItemIcon>
			<ListItemText primary={title} />
		</ListItemButton>
	);
};
